<template>
<widget :title="'App - '+app.app_name" icon="fa-th-large" :max-height="maxHeight">
	<iframe id="appIframe" :src="iframeSrc" :style="{height:iframeHeight}"></iframe>
</widget>
</template>
<script type="text/javascript">
import Widget from "@/components/Widget"

export default {
	name: "AddonAppWidget",
	components: {
		Widget
	},
	props: ["app","maxHeight"],
	data() {
		return {
			openedApp: false,
			uiLocation: "Dashboard Widget"
		}
	},

	computed: {
		iframeSrc() {
			let url = this.app.src

			if (url.indexOf("?") >= 0)
				return url+"&token="+this.$store.sessionToken
			else
				return url+"?token="+this.$store.sessionToken
		},
		appsHere() {
			if ("AddonApp" in this.$store.company && this.$store.company.AddonApp)
				return this.$store.company.AddonApp.filter(app => app.ui_location == this.uiLocation)

			return []
		},
		iframeHeight() {
			let iframe = document.getElementById("appIframe")

			if (iframe) {
				let height = iframe.contentWindow.document.body.scrollHeight
				if (height)
					return height+"px"
			}

			return "400px";
		}
	}
}
</script>

<style type="text/css" scoped>
	iframe {
		width: calc(100% + 14px);
		margin-top: 0;
		margin-left: -7px;
		margin-right: -7px;
		border: none;
	}
</style>